export default "__VITE_ASSET__DBLusHjN__"